import { doc, onSnapshot } from "firebase/firestore"
import { useEffect } from "react"
import { auth } from "../firebaseAuth"
import { db } from "../firebaseFirestore"
import { formatCash, formatNumber } from "../utils/numberFormat"
import { getOptimizedAsset } from "../utils/optimizedImages"

import { useAuthState } from "react-firebase-hooks/auth"
import { useUserStore } from "./stores/userStore"
import { useNamespacedTranslation } from "../hooks/useNamespacedTranslation"
import { UserPointsButtonView } from "react-ui-components/components/UserPointsButtonView"
import { openExchangePointsPopup } from "../utils/lazyPopups"

const NEW_FACIL_COIN_FALLBACK_SRC = "/optimized/new-facil-coin/new-facil-coin-40w.png"

export interface UserPointsProps {
  style?: any
  textStyle?: any
  isNoLink?: boolean
  textPosition?: "LEFT" | "RIGHT"
  size?: number
  iconColor?: string
  iconStyle?: any
  showMinDigits?: number
  precision?: number
  complete?: boolean
  variant?: "text" | "outlined" | "contained"
  className?: string
}

export const UserPoints = function UserPoints(props: UserPointsProps) {
  const {
    size,
    iconColor,
    iconStyle,
    showMinDigits,
    precision,
    complete,
  } = props

  const iconWidth = size || 36
  const coinAsset = getOptimizedAsset("src/assets/icons/NewFacilCoin.png", iconWidth)
  const coinSizes = `(max-width: 640px) ${Math.max(12, Math.round(iconWidth * 0.9))}px, ${iconWidth}px`

  const $iconStyles = { ...iconStyle }
  const { points, isLoggedIn, setPoints } = useUserStore()
  const [user] = useAuthState(auth)
  const { t } = useNamespacedTranslation(['common'])

  useEffect(() => {
    if (!isLoggedIn || !user) {
      return
    }
    const id: any = user.uid

    const querySnapshot = doc(db, "users", id)
    return onSnapshot(querySnapshot, {
      next: (snap) => {
        setPoints(snap?.data()?.points || 0)
      },
      error: () => {
        // Error listening to user points - fail silently
      },
    })
  }, [isLoggedIn, user?.uid, setPoints])

  if (!isLoggedIn) {
    return null
  }

  return (
    <UserPointsButtonView
      coinAlt={t("WinFacil coin")}
      coinColor={iconColor}
      coinHeight={iconWidth}
      coinSizes={coinSizes}
      coinSources={coinAsset?.sources}
      coinSrc={coinAsset?.fallback || NEW_FACIL_COIN_FALLBACK_SRC}
      coinStyle={$iconStyles}
      coinWidth={iconWidth}
      value={String(
        complete
          ? formatNumber(points || 0)
          : formatCash(Math.floor(points || 0), showMinDigits, precision),
      )}
      label={t("points")}
      onClick={() => void openExchangePointsPopup()}
    />
  )

  // return (
  //   <Button
  //     variant={variant}
  //     style={$styles}
  //     className={`flex flex-row gap-1 p-1 ${className} w-full`}
  //     startIcon={
  //       <div className="flex flex-col gap-1 items-center">
  //         <div className="flex flex-row items-center">
  //           <Image
  //             src={require("../assets/icons/NewFacilCoin.png")}
  //             width={size || 20}
  //             style={$iconStyles}
  //             color={iconColor}
  //             alt="winfacil coin"
  //           />

  //           <span className="text-[16px] ml-1">
  //             {complete
  //               ? formatNumber(points || 0)
  //               : formatCash(Math.floor(points || 0), showMinDigits, precision)}
  //           </span>
  //         </div>

  //         <span className="text-[8px] sm:text-xs">{t("points")}</span>
  //       </div>
  //     }
  //     // style={{ backgroundColor: colors.transparent }}
  //     onClick={() => {
  //       PopupService.setPopup(<ExchangePointsScreen />)
  //     }}
  //   ></Button>
  // )
}
